import { render, staticRenderFns } from "./PeriodBudget.vue?vue&type=template&id=d80a0c44"
import script from "./PeriodBudget.vue?vue&type=script&lang=js"
export * from "./PeriodBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports